(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Delivery_option', Delivery_option);

    Delivery_option.$inject = ['$resource'];

    function Delivery_option ($resource) {
        var resourceUrl =  'api/delivery-options/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
